<script setup>
import { computed } from 'vue';
import { CheckboxIndicator, CheckboxRoot } from 'reka-ui';
import { Check } from 'lucide-vue-next';
import { cn } from '@/lib/utils';

// Giữ API `v-model:checked` giống Jetstream Checkbox cũ để thay thế tối thiểu ở các form.
const props = defineProps({
    checked: { type: Boolean, default: false },
    class: { type: null, default: '' },
});

const emits = defineEmits(['update:checked']);

const model = computed({
    get: () => props.checked,
    set: value => emits('update:checked', value),
});
</script>

<template>
    <CheckboxRoot
        v-model="model"
        :class="cn(
            'peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground',
            props.class,
        )"
    >
        <CheckboxIndicator class="flex h-full w-full items-center justify-center text-current">
            <Check class="h-3.5 w-3.5" />
        </CheckboxIndicator>
    </CheckboxRoot>
</template>
